<template>
  <event-flow
    detailTitle="事件详情"
    :total="total"
    :listQuery="listQuery"
    :getList="getList"
  >
    <div slot="content" class="contentWrap">
      <!-- tab -->
      <el-tabs
        id="response_tabs"
        class="tabs"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane name="0" :label="'待督查 ' + count[0]"></el-tab-pane>
        <el-tab-pane name="1,2" :label="'已督查 ' + count[1]"></el-tab-pane>
      </el-tabs>
      <div class="select">
        <div class="type">类型：</div>
        <el-select
          v-model="selectVal"
          placeholder="请选择"
          size="small"
          @change="handleChange"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <!-- 上传 -->
      <el-button
        @click="toUpload"
        class="upload"
        size="small"
        type="primary"
        icon="el-icon-myupload"
        v-show="canPublishSupervise"
      >
        <svg-icon
          class="icon"
          icon-name="myupload"
          icon-color="white"
        ></svg-icon
        >发布
      </el-button>
      <!-- 搜索 -->
      <!-- <div class="searchType">
        类型：
        <el-select v-model="type" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>-->
      <!-- <el-input class="input" v-model="input" placeholder="督查对象">
        <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick"></i>
      </el-input>-->
      <el-date-picker
        v-model="time"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="timechange"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <!-- 变色规则
        1.督察小组 （专家组）变色
        2.紧急调度  事件编号变色
        3.待督查 颜色区分
      -->
      <el-table
        header-row-class-name="customTable"
        row-class-name="customTableBody"
        class="table"
        max-height="634"
        height="634"
        @row-click="handleCurrentChange"
        :data="tableData"
        style="width: 100%"
        highlight-current-row
      >
        <el-table-column label="事件编号" width="200" align="center">
          <template slot-scope="scope">
            <div
              :style="{ color: scope.row.status === 0 ? '#FF817E' : '' }"
              v-show="activeName == '0'"
            >
              {{ scope.row.code }}
            </div>
            <div
              :style="{
                color: scope.row.reply === '存在问题' ? '#FF817E' : '',
              }"
              v-show="activeName != '0'"
            >
              {{ scope.row.code }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="releasetime"
          label="时间"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="construction"
          label="工地名称"
          align="center"
        ></el-table-column>
        <el-table-column label="督查小组" width="120" align="center">
          <template slot-scope="scope">
            <div :style="{ color: scope.row.type === 1 ? '' : '#FF817E' }">
              {{ scope.row.inspection }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="类型" align="center" width="120">
          <template slot-scope="scope">
            <div>{{ scope.row.type == 1 ? "日常调度" : "紧急调度" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="120"
          align="center"
          v-show="activeName === '0'"
        >
          <template slot-scope="scope">
            <div :class="scope.row.status == 0 ? 'status' : 'status2'">
              {{ scope.row.status == 0 ? "待接收" : "已接收" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="activeName === '0' ? '操作' : '督查结果'"
          width="120"
          align="center"
        >
          <template v-if="activeName === '0'" slot-scope="scope">
            <div
              class="operate"
              @click="okay(scope.row)"
              v-if="
                scope.row.status == 0 &&
                userInfo.dept !== '金水区环境攻坚办' &&
                scope.row.inspection == userInfo.dept
              "
            >
              接收
            </div>
          </template>
          <template v-else slot-scope="scope">
            <div :style="{ color: scope.row.color }">{{ scope.row.reply }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="督查结果"
          align="center"
          width="120"
          v-if="activeName != '0'"
        >
          <template slot-scope="scope">
            <div :style="{ color: scope.row.color }">{{ scope.row.reply }}</div>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div
      style="
        text-align: center;
        padding-top: 50px;
        font-size: 14px;
        color: #99a9ba;
      "
      slot="detail"
      v-show="detaildata.gid == undefined"
    >
      请先点击选择调度记录！
    </div>
    <div class="detail" slot="detail" v-show="detaildata.gid != undefined">
      <div class="tableWrap">
        <div class="tableRow" v-for="(item, index) in detailList" :key="index">
          <div class="tableLeft" @click="show(item.name)">{{ item.name }}</div>
          <div class="tableRight" v-show="Array.isArray(item.value)">
            <span
              v-for="(subItem, subIndex) in item.value"
              :key="subIndex"
              class="mark"
              >{{ subItem.name }}：{{ subItem.value }};
            </span>
          </div>
          <div
            :class="['tableRight', item.name === '事件编号' ? 'orange' : '']"
            v-show="!Array.isArray(item.value)"
          >
            {{ item.value }}
          </div>
        </div>
        <div class="tableRow">
          <div class="detailBox" v-if="activeName === '1,2'">
            <div class="header">督查详情</div>
            <div class="pics">
              <span class="name">现场照片:</span>
              <div class="tip" v-if="detaildata.imgurl === ''">暂无图片</div>
              <div
                v-else-if="
                  detaildata.imgurl !== undefined && detaildata.imgurl !== ''
                "
                class="rightBlock"
              >
                <div class="img" v-for="(item, index) in srcList" :key="index">
                  <el-image
                    style="width: 100%; height: 100%"
                    :src="item"
                    :preview-src-list="srcList"
                  >
                  </el-image>
                </div>
              </div>
            </div>
            <div class="address">
              <span class="name">督查地点:</span>
              <span>{{ detaildata.conaddress }}</span>
            </div>
          </div>
        </div>

        <history-dialog
          v-if="isShow"
          :eid="userInfo.eid"
          :construction="construction"
          @close="closeDialog"
        ></history-dialog>
      </div>
    </div>
    <div class="responsibilityBtn" slot="bottom">
      <div
        @click="okay"
        v-show="
          thisstatus && userInfo.dept !== '金水区环境攻坚办' && canReceive
        "
      >
        确认接收
      </div>
    </div>
  </event-flow>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
import EventFlow from "@/layout/Event/EventLayout";
import HistoryDialog from "@/components/Home/HistoryDialog";
// import Pagination from "@/components/common/Pagination";

export default {
  components: {
    EventFlow,
    HistoryDialog,
  },
  data() {
    return {
      activeName: "0",
      input: "",
      data: [],
      time: [],
      type: "",
      total: 0,
      typeList: [],
      detaildata: [],
      thisstatus: false,
      listQuery: {
        page: 1,
        limit: 10,
      },
      questionList: [
        {
          date: "05-07",
          content: "因扬尘问题进行约谈",
        },
        {
          date: "05-29",
          content: "因扬尘问题进行约谈",
        },
      ],
      detailList: [],
      tableData: [],
      isShow: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      construction: "", // 工地名称
      selectVal: "",
      options: [
        { value: "", label: "全部" },
        { value: 1, label: "日常调度" },
        { value: 2, label: "紧急调度" },
      ],
      count: [0, 0],
      replyMap: {
        0: "待确认",
        1: "未发现问题",
        2: "存在问题",
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    ...mapGetters(["canPublishSupervise"]),
    canReceive() {
      return this.detaildata.inspection == this.userInfo.dept;
    },
    srcList() {
      return this.detaildata.imgurl.split("|");
    },
  },
  mounted() {
    console.log(this.canPublishSupervise);
    this.getList();
    this.getCount();
  },
  methods: {
    timechange(val) {
      console.log(val);
      if (val == null) {
        this.time = [];
      } else {
        this.time = val;
      }
      this.getList();
      this.getCount();
    },
    async getList(e) {
      if (!e) {
        this.listQuery.page = 1;
      }
      try {
        const params = {};
        params.pid = this.userInfo.platformid;
        params.uid = this.userInfo.gid;
        params.page = this.listQuery.page;
        params.size = this.listQuery.limit;
        params.starttime =
          this.time && this.time.length > 0 ? this.time[0] + " 00:00:00" : "";
        params.endtime =
          this.time && this.time.length > 0 ? this.time[1] + " 23:59:59" : "";
        params.reply = this.activeName;
        params.type = this.type;
        params.inspection = this.userInfo.dept;
        if (
          this.userInfo.dept == "pm2.5专家组" ||
          this.userInfo.dept == "金水区环境攻坚办"
        ) {
          params.inspection = "";
        }
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.DSIPATCH, params);
        console.log("调度列表", res);
        res.rows.forEach((item) => {
          if (item.reply === 0) {
            item.reply = "待确认";
            item.color = "#009157";
          } else if (item.reply === 1) {
            item.reply = "未发现问题";
            item.color = "#353E56";
          } else if (item.reply === 2) {
            item.reply = "存在问题";
            item.color = "#FF817E";
          }
        });
        this.tableData = res.rows;
        this.total = res.total;
        // 从手机端确认 导致切换tab时候没有重新请求count 所以导致count和list的长度不一致
        if (this.activeName == "0") {
          if (this.count[0] != this.total) {
            this.count = [this.total, this.count[1]];
          }
        } else {
          if (this.count[1] != this.total) {
            this.count = [this.count[0], this.total];
          }
        }
        if (res.rows.length) {
          this.gid = res.rows[0].gid;
          this.getdetail();
        }
        // this.fmttable();
      } catch (e) {
        console.log(e);
      }
    },
    // fmttable() {
    //   const data = [];
    //   this.data.forEach((item) => {
    //     if (this.activeName == item.status) {
    //       data.push(item);
    //     }
    //   });
    //   this.tableData = data;
    // },
    handleCurrentChange(val) {
      // this.currentRow = val;
      if (this.gid == val.gid) return;
      console.log(this.time);
      this.gid = val.gid;
      this.construction = val.construction;
      this.getdetail();
    },
    async getdetail() {
      try {
        const res = await getServerData(
          APIMAP.DSIPATCH + "/" + this.gid,
          {
            gid: this.gid,
            uid: this.userInfo.gid,
          },
          "get"
        );
        console.log("调度详情", res);
        this.detaildata = res;
        this.fmtdetail();
      } catch (e) {
        console.log(e);
      }
    },
    async okay({ gid }) {
      try {
        const res = await getServerData(
          APIMAP.DSIPATCH,
          {
            gid: gid ? gid : this.gid,
            status: 1,
          },
          "put"
        );
        console.log(res);
        this.detaildata = res;
        this.$message({
          type: "success",
          message: "已接收",
        });
        this.activeName = "0";
        this.getList();
        // this.tableData.forEach((item, i) => {
        //   if (item.gid == res.gid) {
        //     this.$set(this.tableData, i, res);
        //   }
        // });
        // this.fmtdetail();
      } catch (e) {
        console.log(e);
      }
    },
    fmtdetail() {
      var res = this.detaildata;
      console.log(res.status);
      this.thisstatus = res.status == 0 ? true : false;
      this.detailList = [];
      this.detailList.push(
        {
          name: "监理",
          type: "supervise",
          value: res.consupervision,
        },
        {
          name: "甲方",
          type: "partA",
          value: res.conbuilding,
        },
        {
          name: "乙方",
          type: "partB",
          value: res.conconstruction,
        },
        {
          name: "事件类型",
          type: "partB",
          value: res.type === 1 ? "日常调度" : "紧急调度",
        },
        {
          name: "事件编号",
          type: "partB",
          value: res.code,
        },
        {
          name: "工地名称",
          type: "partB",
          value: res.construction,
        },
        {
          name: "工地地址",
          type: "partB",
          value: res.conaddress,
        },
        {
          name: "信用等级",
          type: "partB",
          value: res.conlevel,
        },
        {
          name: "历史问题",
          type: "partB",
          value: [
            {
              name: "整改",
              value: res.rectify,
            },
            {
              name: "扣分",
              value: res.deduction,
            },
            {
              name: "处罚",
              value: res.punishment,
            },
          ],
        },
        {
          name: "发布人",
          type: "time",
          value: res.username,
        },
        {
          name: "发布时间",
          type: "time",
          value: res.releasetime,
        },
        {
          name: "接收调度",
          type: "status",
          value: res.status == 0 ? "待接收" : "已接收",
        },
        {
          name: "督察小组",
          type: "prevDepartment",
          value: res.inspection,
        },
        {
          name: "存在问题",
          type: "reply",
          value: this.replyMap[res.reply],
        }
      );
    },
    handleClick() {
      // this.fmttable();
      this.detailList = [];
      this.detaildata = {};
      this.thisstatus = false;
      this.getList();
    },
    handleIconClick(e) {
      console.log(e);
    },
    toUpload() {
      this.$nv("/pubArrange", { from: "superviseArrange" });
    },
    show(type) {
      if (type === "历史问题") {
        this.isShow = true;
      }
    },
    closeDialog() {
      this.isShow = false;
    },
    handleChange(val) {
      console.log(val);
      this.type = val;
      this.getList();
      this.getCount();
    },
    async getCount() {
      try {
        let params = {};
        params.pid = this.userInfo.platformid;
        params.type = 2;
        params.userdept = this.userInfo.dept;
        if (this.time.length > 0) {
          params = {
            ...params,
            startTime: this.time[0] + " 00:00:00",
            endTime: this.time[1] + " 23:59:59",
          };
        }
        if (this.type !== "") {
          params = {
            ...params,
            dispatchtype: this.type,
          };
        }
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.COUNT, params);
        console.log("响应数据", res);
        const count = [];
        res.forEach((item) => {
          if (item.type === "待督查") {
            count.push(item.num);
          } else if (item.type === "已督查") {
            count.push(item.num);
          }
        });
        this.count = count;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.contentWrap {
  position: relative;
}
.input {
  width: 300px;
  position: absolute;
  right: 0;
  top: -10px;
}

.upload {
  position: absolute;
  right: 0;
  top: 55px;
}
.upload svg {
  vertical-align: middle;
  margin: -3px 5px 0 0;
}
.icon {
  width: 16px;
  height: 16px;
}

.table {
  margin-top: 20px;
  color: #353e56;
}

.status {
  color: var(--themeColor);
  border: 1px solid var(--themeColor);
  width: 78px;
  height: 32px;
  border-radius: 5px;
  margin: 0 auto;
  line-height: 32px;
}
.status2 {
  color: #f78b25;
  border: 1px solid #f78b25;
  width: 78px;
  height: 32px;
  border-radius: 5px;
  margin: 0 auto;
  line-height: 32px;
}
.select {
  width: 156px;
  height: 32px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  .type {
    color: #909ead;
  }
  .el-select {
    width: 105px;
  }
}

.demo-image__preview {
  width: 160px;
  .el-image {
    margin: 0 4px;
  }
}
.detail {
  min-height: 675px;
  height: 700px;
  overflow: scroll;
}
.detailItem {
  font-size: 15px;
  margin-top: 24px;
  display: flex;
  color: #707b86;
  .detailContent {
    color: #3b445a;
  }
}

.detailDetail {
  box-sizing: border-box;
  padding: 16px;
  background: #f5f5f5;
  margin-top: 16px;
  border-radius: 2px;
}

.detailDetailWrap {
  font-size: 14px;
  color: #99a9ba;
  display: flex;
  width: 100%;
  &:not(:first-child) {
    margin-top: 14px;
  }
  .detailDate {
    position: relative;
    padding-left: 12px;
    margin-right: 6px;
    &::before {
      content: "";
      position: absolute;
      top: 7px;
      left: -6px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: RGBA(255, 197, 95, 1);
    }
  }
}

.tableWrap {
  margin-top: 26px;
  border-top: 1px solid #e2e5ec;
  .tableRow {
    font-size: 15px;
    display: flex;

    .tableRight {
      padding: 16px 0;
      width: 296px;
      color: #3b445a;
    }
    .tableLeft,
    .tableRight {
      min-height: 56px;
      padding-left: 12px;
      box-sizing: border-box;
      border: 1px solid #e2e5ec;
    }

    .tableLeft {
      width: 140px;
      color: #707b86;
      border-right: none;
      line-height: 56px;
      &:first-child {
        border-top: none;
      }
    }

    .tableRight {
      border-top: none;
    }
  }
  .detailBox {
    width: 410px;
    background: #f5f5f5;
    margin-top: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 8px 15px 8px 8px;
    .header {
      color: #707b86;
      margin-bottom: 10px;
      font-weight: 600;
    }
    .pics,
    .address {
      color: #707b86;
      margin-bottom: 6px;
      .tip {
        display: inline-block;
      }
      .rightBlock {
        display: inline-block;
        width: 76%;
        vertical-align: text-top;
        .img {
          display: inline-block;
          vertical-align: top;
          width: 46px;
          height: 35px;
          margin: 0 15px 10px 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .name {
        display: inline-block;
        margin-right: 10px;
      }
    }
  }
}

.searchType {
  position: absolute;
  top: -5px;
  right: 0px;
  font-size: 16px;
  color: #909ead;
}

.responsibilityBtn {
  display: flex;
  justify-content: flex-end;
  div {
    margin-top: 20px;
    width: 150px;
    height: 42px;
    background: var(--themeColor);
    border-radius: 5px;
    text-align: center;
    line-height: 42px;
    color: white;
    cursor: pointer;
  }
}

.mark {
  margin-right: 8px;
  color: #009157;
}
.operate {
  color: var(--themeColor);
}
.orange {
  color: #ff817e !important;
}
</style>